module.exports = __webpack_public_path__ + "img/egg.ceaf9c81.png";